import {
  POPULATE_SIGNUP_FORM,
} from '../actions/signup-form-data';

interface SignupFormReducerType {
  type: string;
  data: SignupFormDataType;
}
export default (state = {}, action: SignupFormReducerType) => {
  switch (action.type) {
    case POPULATE_SIGNUP_FORM: {
      // destructure action to retrieve data without type
      // eslint-disable-next-line no-unused-vars
      const { type, ...data } = action;
      return {
        ...state,
        ...data,
      };
    }
    default:
      return state;
  }
};
